import { a as m, e as d, l as k, d as p, c as C, f as g } from "../constants-RT-_BdF-.mjs";
import { b as w } from "../constants-RT-_BdF-.mjs";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var h = v;
function v(e, t) {
  if (typeof e != "string")
    throw new TypeError("argument str must be a string");
  for (var n = {}, a = t || {}, s = a.decode || N, o = 0; o < e.length; ) {
    var r = e.indexOf("=", o);
    if (r === -1)
      break;
    var i = e.indexOf(";", o);
    if (i === -1)
      i = e.length;
    else if (i < r) {
      o = e.lastIndexOf(";", r - 1) + 1;
      continue;
    }
    var f = e.slice(o, r).trim();
    if (n[f] === void 0) {
      var c = e.slice(r + 1, i).trim();
      c.charCodeAt(0) === 34 && (c = c.slice(1, -1)), n[f] = S(c, s);
    }
    o = i + 1;
  }
  return n;
}
function N(e) {
  return e.indexOf("%") !== -1 ? decodeURIComponent(e) : e;
}
function S(e, t) {
  try {
    return t(e);
  } catch {
    return e;
  }
}
function u({
  cookieData: e,
  cookieName: t,
  schema: n
}) {
  const { [t]: a } = h(e), s = a ? l(a) : void 0;
  if (!s)
    return;
  const o = n.safeParse(s);
  if (o.success)
    return o.data;
  console.error(o.error.errors);
}
function l(e) {
  try {
    return JSON.parse(e);
  } catch {
    console.error("Invalid JSON syntax:", e);
    return;
  }
}
function y(e) {
  return u({
    cookieData: e,
    cookieName: m,
    schema: d
  });
}
function O(e) {
  return u({
    cookieData: e,
    cookieName: k,
    schema: p
  });
}
const U = (e, t, n) => {
  var s;
  const a = e.find((o) => {
    const [r] = (o == null ? void 0 : o.split("=")) ?? "";
    return r === t;
  });
  if (a) {
    const o = (s = a.split("=")) == null ? void 0 : s[1];
    if (o) {
      const r = l(decodeURIComponent(o));
      if (n) {
        const i = n.safeParse(r);
        if (i.success)
          return i.data;
      } else
        return r;
    }
  }
};
function x(e) {
  return u({
    cookieData: e,
    cookieName: C,
    schema: g
  });
}
export {
  m as adbContextCookieName,
  d as adbContextCookieSchema,
  C as cartCookieName,
  g as cartCookieSchema,
  U as getArrayCookie,
  l as jsonSafeParse,
  w as loginUserDetailFieldRegex,
  k as loginUserDetailsCookieName,
  p as loginUserDetailsSchema,
  y as parseAdbContextCookie,
  x as parseCartCookie,
  u as parseJsonCookie,
  O as parseLoginUserDetailsCookie
};
//# sourceMappingURL=index.mjs.map
